
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { WorkOrder } from '../../../../entities/job/workorder';
import { ContactMergeData } from './contact.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Job
})
export class JobMergeData {

    @MergeField()
    _id: string = ''

    @MergeField()
    jobNumber: string;

    @MergeField()
    status: string;

    @MergeField()
    name: string;

    @MergeField()
    mode: string;

    @MergeField()
    description: string;

    @MergeField()
    customerPO: string;

    @MergeField()
    customerWO: string;

    @MergeField()
    type: string;

    @MergeField()
    priority: string;

    @MergeField()
    tags: string;

    @MergeField()
    zones: string;

    @MergeField()
    startDate: string;

    @MergeField()
    dueDate: string;

    @MergeField()
    completedDate: string;

    @MergeField()
    finalisedDate: string = ''

    @MergeField()
    totalSell: string = ''

    @MergeField()
    totalBuy: string = ''

    @MergeField()
    pricebook: string = ''

    @MergeField()
    timezone: string = ''

    // Superseded by nextAppointmentStartDate; still filled so templates written against it keep printing.
    @MergeField({
        displayName: 'Next Appointment Date (deprecated)'
    })
    nextAppointmentDate: string = ''

    // Superseded by nextAppointmentStartDateTime; still filled so templates written against it keep printing.
    @MergeField({
        displayName: 'Next Appointment Date Time (deprecated)'
    })
    nextAppointmentDateTime: string = ''

    @MergeField()
    nextAppointmentStartDate: string = ''

    @MergeField()
    nextAppointmentStartTime: string = ''

    @MergeField()
    nextAppointmentStartDateTime: string = ''

    @MergeField()
    nextAppointmentEndDate: string = ''

    @MergeField()
    nextAppointmentEndTime: string = ''

    @MergeField()
    nextAppointmentEndDateTime: string = ''

    @MergeField()
    nextAppointmentResourceName: string = ''

    @MergeField()
    ganttUrl: string = ''

    @MergeField()
    ganttUrlHtml: string = ''

    workOrders: WorkOrder[];

    [key: string]: any;
}

export const JobMergeSchema = getSchema(JobMergeData);
